import { SUSTAINABILITY_ATTRIBUTES } from "../constants/attributesByGroups"

export const deleteGuion = (attr) => {
  if (
    typeof attr.value === "string" && 
    attr.title !== SUSTAINABILITY_ATTRIBUTES["attributes"].epd
    ) {
    let valueWithoutGuion = attr.value.split('_').join(' ')
    attr.value = valueWithoutGuion
  }
}

export const determineIfShowAlternativePolymer = (general = {}) => {
  // Logic to management if show alternative polymer
  const { composition } = general
  const specificCompositionToAddLocalLogo = ["Olefinas Termoplásticas", "TPO"]
  const showAlternativePolymer = specificCompositionToAddLocalLogo.includes(composition)
  
  return showAlternativePolymer ? { alternativePolymer: true } : {}
}

export const constructEpdInformation = (epds) => {
  const epd = epds?.edges[0]?.node

  if (epd) {
    return {
      epd: epd.name,
      epdCertificateFile: epd.certificate,
      epdCertificateFileExpires: epd.fileExpires,
      epdNotExpires: epd.fileNotExpires,
    }
  }
}